import loadable from '@loadable/component'

export const LatestRacTable = loadable(() => import('./LatestRacTable'))

export type { RacTableItem, RacTableProps } from './LatestRacTable'
